import { Controller } from '@hotwired/stimulus';

// 給与一覧リデザイン (#1871) のスクロール検知。
// 従業員ヘッダが画面上端に固定されたら、メモ行を畳んで表をコンパクトにする。
export default class extends Controller {
  connect() {
    this.onScroll = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.onScroll();
  }

  disconnect() {
    window.removeEventListener('scroll', this.onScroll);
  }

  onScroll() {
    // テーブル上端がビューポート上端に達したら sticky 状態とみなす。
    const top = this.element.getBoundingClientRect().top;
    this.element.classList.toggle('scrolled', top <= 0);
  }
}
